import { render } from "./OrderOneStrykerStatsDialog.vue?vue&type=template&id=5885cb0b"
import script from "./OrderOneStrykerStatsDialog.vue?vue&type=script&lang=js"
export * from "./OrderOneStrykerStatsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__